import type { FC, SVGProps } from "react";

const IconChevron: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M5 9L1 5L5 1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconChevron;